import BaseError from "./BaseError";

export default class BadGatewayError extends BaseError {
  constructor(data) {
    super(data);
    this.name = "BadGatewayError";
  }
}
